export const DEFAULT_STYLE = `
      body {
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
        font-size: 14px;
        line-height: 1.6;
      }
      p {
        margin: 0.5em 0;
      }
      table, td, th {
        border: 1px solid black;
      }
      table {
        border-collapse: collapse;
      }
      .mce-content-body[data-mce-placeholder]:not(.mce-visualblocks)::before {
        color: #94a3b8;
        content: attr(data-mce-placeholder);
        position: absolute;
        pointer-events: none;
      }
      body.mce-content-body:not(.mce-visualblocks)[data-mce-placeholder]:empty::before {
        color: #94a3b8;
        content: attr(data-mce-placeholder);
        position: absolute;
        pointer-events: none;
      }
      .template-variable-highlight {
        background-color: #FEF3C7;
        color: #92400E;
        padding: 2px 4px;
        border-radius: 3px;
        font-weight: 500;
        cursor: pointer;
        user-select: none;
        border: 1px dashed #92400E; /* dodato */
      }
      a.template-link-highlight {
        background-color: #FEF3C7;
        color: #92400E;
        padding: 2px 4px;
        border-radius: 3px;
        text-decoration: underline;
        border: 1px dashed #92400E;
      }
      .template-loop-highlight {
        background-color: #DBEAFE;
        color: #1E40AF;
        border: 1px dashed #1E40AF;
        padding: 2px 4px;
        border-radius: 3px;
        font-weight: 500;
        cursor: pointer;
        user-select: none;
      }
      .template-condition-highlight {
        background-color: #D1FAE5;
        color: #059669;
        border: 1px dashed #059669;
        padding: 2px 4px;
        border-radius: 3px;
        font-weight: 500;
        cursor: pointer;
        user-select: none;
      }
      .template-function-highlight {
        background-color: #F3E8FF;
        color: #6B21A8;
        padding: 2px 4px;
        border-radius: 3px;
        font-weight: 500;
        cursor: pointer;
        user-select: none;
        border: 1px dashed #6B21A8;
      }
      .template-row-condition-indicator {
        display: inline-block;
        background-color: #D1FAE5;
        color: #059669;
        border: 1px solid #059669;
        padding: 1px 6px;
        border-radius: 3px;
        font-size: 11px;
        font-weight: 600;
        margin-right: 4px;
        cursor: pointer;
        user-select: none;
        vertical-align: middle;
      }
      .template-row-condition-indicator::before {
        content: "if";
        font-family: monospace;
      }
      .template-row-condition-indicator[data-condition-type="unless"]::before {
        content: "unless";
      }
    `;
